import { SiteShell } from "@/components/site/SiteShell";
import { PageHero } from "@/components/site/PageHero";
import { SEO, breadcrumbSchema } from "@/components/site/SEO";
import { EQUIPMENT } from "@/lib/siteData";
import { Camera, Aperture, Plane, Lightbulb, Volume2, Settings, Truck, Layers, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ROUTE_SEO } from "@/lib/routeSeo";
import { Link } from "react-router-dom";

const SECTIONS = [
  { key: "cameras", title: "Cameras", icon: Camera },
  { key: "lenses", title: "Lenses", icon: Aperture },
  { key: "drones", title: "Aerial / Drones", icon: Plane },
  { key: "lighting", title: "Lighting", icon: Lightbulb },
  { key: "audio", title: "Audio", icon: Volume2 },
  { key: "support", title: "Support & Grip", icon: Settings },
  { key: "vehicles", title: "Vehicles", icon: Truck },
  { key: "post", title: "Post-Production", icon: Layers },
];

export default function Equipment() {
  return (
    <SiteShell>
      <SEO title={ROUTE_SEO["/equipment"].title} description={ROUTE_SEO["/equipment"].meta} path="/equipment" jsonLd={breadcrumbSchema([{name: "Home", path: "/"}, {name: "Equipment"}])} />
      <PageHero kicker="Capabilities" title={ROUTE_SEO["/equipment"].h1} subtitle="Cinema-grade equipment owned and maintained in-house. We invest in our own kit so you don’t pay rental markups for the basics." breadcrumb={[{name: "Home", path: "/"}, {name: "Equipment"}]} />
      <section className="section-pad">
        <div className="container-site grid grid-cols-1 md:grid-cols-2 gap-6">
          {SECTIONS.map(s => (
            <div key={s.key} className="rounded-2xl border border-border bg-card p-7">
              <div className="flex items-center gap-3 mb-5">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-[hsl(225,16%,14%)] border border-border text-[hsl(var(--primary))]"><s.icon className="h-5 w-5" /></span>
                <h2 className="font-display uppercase text-foreground text-xl tracking-[0.02em]">{s.title}</h2>
              </div>
              <ul className="space-y-2 text-sm text-foreground/85">
                {(EQUIPMENT[s.key] || []).map(item => (<li key={item} className="flex items-start gap-2"><span className="mt-2 inline-block h-1 w-1 rounded-full bg-[hsl(var(--primary))] shrink-0" />{item}</li>))}
              </ul>
            </div>
          ))}
        </div>
        <div className="container-site mt-16 text-center">
          <p className="text-sm text-muted-foreground">Need something specific? We have strong relationships with every rental house in Cape Town - anything not in-house, we source.</p>
          <Button asChild className="mt-6 h-12 rounded-full bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] hover:brightness-110 px-6"><Link to="/contact">Discuss your kit needs <ArrowRight className="ml-2 h-4 w-4" /></Link></Button>
        </div>
      </section>
    </SiteShell>
  );
}
